<template>
  <div :class="['proposal-row px-6 py-3', { 'has-divider': hasDivider }]">
    <div class="d-flex align-baseline text-5">
      <div class="darkgray--text" style="width:50px">
        #{{ proposalItem.id }}
      </div>
      <div class="flex-3 text-left">
        <router-link
          class="text-decoration-none line-height-25"
          :to="{
            name: 'TendermintProposal',
            params: { proposalId: proposalItem.id },
          }"
          >{{ proposalItem.title }}</router-link
        >
      </div>
      <div
        style="width:120px"
        :class="[
          'text-left text-uppercase pl-5',
          `status-${proposalItem.status.number}`,
        ]"
      >
        {{ proposalItem.status.text }}
      </div>
      <div class="flex-2 text-right darkgray--text pr-3">
        <span v-if="proposalItem.status.number > 1">
          {{
            new Date(proposalItem.voteStartTime)
              | datetime("yyyy-MM-dd HH:mm:ss")
          }}
        </span>
        <span v-else>-</span>
      </div>
      <div class="flex-2 text-right darkgray--text">
        {{
          new Date(proposalItem.submitTime) | datetime("yyyy-MM-dd HH:mm:ss")
        }}
      </div>
      <div class="flex-2 text-right">
        <span>
          {{
            proposalItem.totalDeposit
              | denomConverter(currentProject.staking)
              | denomFormat
          }}
        </span>
        <span class="text-6 darkgray--text text-uppercase">
          {{ currentProject.staking.token }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const statusMap = {
  1: "Deposit Period",
  2: "Voting Period",
  3: "Passed",
  4: "Rejected",
};
const statusNameMap = {
  DepositPeriod: 1,
  VotingPeriod: 2,
  ValidatorVotingPeriod: 2,
  Passed: 3,
  Rejected: 4,
};
export default {
  props: {
    hasDivider: Boolean,
    dataItem: Object,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
    }),
    proposalItem() {
      return {
        id: this.dataItem.id,
        title:
          this.dataItem.content.value?.title || this.dataItem.content.title || `Proposal #${this.dataItem.id}`,
        status: {
          number:
            this.dataItem.status ||
            statusNameMap[this.dataItem.proposal_status],
          text:
            statusMap[
              this.dataItem.status ||
                statusNameMap[this.dataItem.proposal_status]
            ],
        },
        submitTime: this.dataItem.submit_time,
        voteStartTime: this.dataItem.voting_start_time,
        totalDeposit: this.dataItem.total_deposit[0]?.amount ?? 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.proposal-row {
  &.has-divider {
    border-top: 1px solid #e9ebff;
  }
  .status-1 {
    color: var(--v-warning-base);
  }
  .status-2 {
    color: var(--v-info-base);
  }
  .status-3 {
    color: var(--v-green-base);
  }
  .status-4 {
    color: var(--v-error-base);
  }
}
</style>
